"use strict";var E;exports.VEG_CLASSIFIER=void 0,(E=exports.VEG_CLASSIFIER||(exports.VEG_CLASSIFIER={})).DEFAULT="DEFAULT",E.VEG="VEG",E.NONVEG="NONVEG",E.EGG="EGG";
//# sourceMappingURL=types.js.map
